import Vue from 'vue';
import EventService from "../../services/EventService";

export const namespaced = true;

export const state = {
    loading: 0,
    videoarchives: {},
};

// Archives are indexed by appointmentId
export const mutations = {
    SET_LOADING(state, percent) {
        state.loading = percent;
    },
    SET_VIDEOARCHIVES(state, payload) {
        Vue.set(state.videoarchives, payload.id, payload.data);
    },
};

export const actions = {
    async fetchArchives(context, appointmentId) {
        return EventService.getVideoArchivesForAppointment(appointmentId)
            .then(response => {
                context.commit('SET_LOADING', 50);
                context.commit('SET_VIDEOARCHIVES', {id: appointmentId, data: response.data});
            })
            .catch(error => {
               console.log('getVideoArchivesForAppointment failed: ', error.message)
            })
            .finally(() => {
                context.commit('SET_LOADING', 100);
            });
    }
};


export const getters = {
    byAppointmentId: (state) => (appointmentId) => {
        let archives = state.videoarchives[appointmentId];
        return (archives ? archives : []);
    },
    isRecording: (state) => (appointmentId) => {
        if (! state.videoarchives[appointmentId]) { return false; }

        for (let i=0; i<state.videoarchives[appointmentId].length; i++) {
            if (! state.videoarchives[appointmentId][i].stopped_at) {
                return true;
            }
        }
        return false;
    },
};

